export const profile = {
  name: "Sai Krishna Chaitanya Lanka",
  shortName: "Krishna Chaitanya",
  role: "Full Stack Developer",
  location: "Hyderabad, India",
  email: "krishnachaitu1298@gmail.com",
  website: "https://www.imekrrish.site/",
  linkedin: "https://www.linkedin.com/in/lanka-sai-krishna-chaitanya-288549207/",
  github: "https://github.com/imekrrish",
  githubHandle: "@imekrrish",
  summary:
    "I am a full stack developer. I enjoy working on frontend, backend, mobile apps, and AI features. I like understanding how the complete product works.",
};

export const projects = [
  {
    id: "curapay", number: "01", category: "HEALTHCARE PLATFORM",
    title: "Fintech Health Care App", period: "12/2025 TO PRESENT",
    systems: "Web, mobile, APIs, and data",
    summary: "Built connected patient experiences across web, mobile, backend, and integrations.",
    metrics: [{ value: "4", label: "CONNECTED AREAS" }, { value: "2", label: "CLIENT APPS" }, { value: "1", label: "BACKEND MIGRATION" }],
    stack: ["React Native", "React", "Node.js", "Prisma", "PostgreSQL"], tone: "red",
  },
  {
    id: "talent", number: "02", category: "AI TALENT PLATFORM",
    title: "Talent Acquisition Tool", period: "07/2024 TO PRESENT",
    systems: "Screening, matching, and RAG",
    summary: "Built an AI tool for résumé screening, job matching, and interview questions.",
    metrics: [{ value: "3", label: "AI WORKFLOWS" }, { value: "1", label: "MVP DELIVERED" }, { value: "1", label: "RAG PIPELINE" }],
    stack: ["React", "Node.js", "MongoDB", "OpenAI API", "RAG"], tone: "white",
  },
  {
    id: "lims", number: "03", category: "ENTERPRISE LIMS",
    title: "LIMS Project", period: "03/2024 TO 12/2025",
    systems: "Production workflows and performance",
    summary: "Built features, fixed production issues, and improved slow laboratory workflows.",
    metrics: [{ value: "4", label: "SYSTEM LAYERS" }, { value: "1", label: "LIVE PLATFORM" }, { value: "3", label: "WORK AREAS" }],
    stack: ["ASP.NET", "VB.NET", "C#", "SQL Server"], tone: "gray",
  },
];

export const stackLayers = [
  { name: "Interface", code: "01", items: ["React", "React Native", "TypeScript", "JavaScript"] },
  { name: "Services", code: "02", items: ["Node.js", "Express", "ASP.NET", "C#", "REST APIs"] },
  { name: "Data", code: "03", items: ["PostgreSQL", "Prisma", "SQL Server", "MongoDB"] },
  { name: "AI", code: "04", items: ["OpenAI API", "RAG", "AI assistants"] },
];

export const experience = {
  company: "Progience", role: "Full Stack Developer", period: "MAR 2024 TO PRESENT", location: "Hyderabad, India",
  statement: "My work covers frontend, backend, APIs, and databases.",
  points: [
    "Joined as an intern and moved into a full time developer role.",
    "Built features for web apps, mobile apps, backend services, and AI tools.",
    "Fixed production issues by checking the complete flow from the screen to the database.",
  ],
};

export const education = {
  degree: "B.Tech · Computer Science & Engineering",
  school: "National Institute of Technology, Andhra Pradesh",
  year: "2024",
};
